import React, { useEffect, useState } from "react";
import styles from "./SummaryPage.module.css";

const SummaryPage = () => {
    const [stages, setStages] = useState([]);
    const [activeStage, setActiveStage] = useState(0);
    const tabOptions = [
        { id: 1, name: "Overview" },
        { id: 2, name: "Instructions" },
        
    ];
    const [focusedTab, setFocusedTab] = useState(tabOptions[0]);

    useEffect(() => {
        const stored = localStorage.getItem("instructionData");
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                setStages(parsed?.stages || []);
            } catch (err) {
                console.error("Error parsing saved data:", err);
                setStages([]);
            }
        }
    }, []);

    const renderLeftData = (stage) => {
        if (!stage || !stage.rows) return null;

        const sections = [];

        stage.rows.forEach((row) => {
            if (!row?.cols) return;
            row.cols.forEach((col) => {
                const el = col?.element;
                if (!el || !el.type) return;

                if (el.type === "bold") {
                    const heading = (el.value || el.label || "").trim();
                    if (/instruction/i.test(heading)) return;
                    sections.push({
                        title: heading || "Untitled",
                        fields: [],
                    });
                } else if (["input", "dropdown"].includes(el.type)) {
                    if (sections.length === 0)
                        sections.push({ title: "Untitled", fields: [] });
                    sections[sections.length - 1].fields.push({
                        label: el.label || "",
                        value: el.value || "",
                    });
                }
            });
        });

        return (
            <div className={styles.leftSection}>
                {sections.map((sec, i) => (
                    <div key={i} className={styles.card}>
                        <h3 className={styles.cardTitle}>{sec.title}</h3>
                        {sec.fields.length > 0 ? (
                            sec.fields.map((f, j) => (
                                <div key={j} className={styles.row}>
                                    <span className={styles.label}>{f.label}</span>
                                    <span className={styles.value}>{f.value}</span>
                                </div>
                            ))
                        ) : (
                            <div className={styles.emptyField}>No data available</div>
                        )}
                    </div>
                ))}
            </div>
        );
    };

    const renderRightInstructions = (stage) => {
        if (!stage || !stage.rows) return null;

        const instructions = [];
        stage.rows.forEach((row) => {
            if (!row?.cols) return;
            row.cols.forEach((col) => {
                const el = col?.element;
                if (!el || !el.type) return;

                if (["instruction", "text"].includes(el.type)) {
                    instructions.push(el.value || "");
                }
            });
        });

        return (
            <div className={styles.rightSection}>
                <div className={styles.card}>
                    <h3 className={styles.cardTitle}>Instructions</h3>
                    {instructions.length > 0 ? (
                        instructions.map((inst, i) => (
                            <div key={i} className={styles.instructionRow}>
                                <span className={styles.instructionIndex}>
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span className={styles.instructionText}>{inst}</span>
                            </div>
                        ))
                    ) : (
                        <p className={styles.empty}>No instructions added.</p>
                    )}
                </div>
            </div>
        );
    };

    if (!stages?.length)
        return <div className={styles.empty}>No data found</div>;

    const active = stages[activeStage];


    return (
        <div className={styles.container}>
            <div className={styles.stageTabs}>
                {stages.map((stage, i) => (
                    <button
                        key={stage.id || i}
                        onClick={() => setActiveStage(i)}
                        className={`${styles.tab} ${i === activeStage ? styles.active : ""
                            }`}
                    >
                        {stage.name || `Stage ${i + 1}`}
                    </button>
                ))}
            </div>

            <div className={styles.contentArea}>
                {renderLeftData(active)}
                {renderRightInstructions(active)}
            </div>
        </div>
    );
};

export default SummaryPage;
